// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"531":"92380a9b","762":"0a2d3bd9"}[chunkId] + ".chunk.css";
};